/* ==================================================================== */
/* UNDENIABLE — Laufzeit der Produktseite (v20)                          */
/* ------------------------------------------------------------------ */
/* Ein Scroll-Loop (rAF) treibt alles, was am Scrollen haengt:          */
/*   Buehne      3D-Flakon-Anflug (undeniable-bottle3d.js), Video-Zoom  */
/*   Noten       horizontale Tafeln, gepinnt                            */
/*   Studien     Zahlen-Wechsel, gepinnt                                */
/*   Fuer sie    Zitat Wort fuer Wort, Profilbalken                     */
/* Dazu: Zitat-Karussell, Sticky-Leiste, Videos nur im Bild abspielen.  */
/* Alles idempotent (Theme-Editor).                                     */
/* ==================================================================== */

(function () {
  'use strict';

  var root = document.documentElement;
  root.classList.add('und-js');

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = function () { return window.innerWidth >= 1000; };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };

  /* ---------- Scroll-Loop ---------- */

  var tasks = [];
  var frame = 0;

  function tick() {
    frame = 0;
    for (var i = 0; i < tasks.length; i++) tasks[i]();
  }

  function request() { if (!frame) frame = requestAnimationFrame(tick); }
  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request);

  /* Fortschritt einer gepinnten Szene: 0 = Pin beginnt, 1 = Pin endet */
  function pinProgress(el, pinH) {
    var r = el.getBoundingClientRect();
    var total = r.height - pinH;
    if (total <= 0) return 0;
    return clamp(-r.top / total, 0, 1);
  }

  /* ---------- Reveal ---------- */

  var revealIO = null;

  function setupReveal(scope) {
    var nodes = scope.querySelectorAll('[data-und-reveal]:not(.is-in)');
    if (!nodes.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          revealIO.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    }
    nodes.forEach(function (n) { revealIO.observe(n); });
  }

  /* ---------- Videos nur im Bild abspielen ---------- */

  var videoIO = null;

  function setupVideos(scope) {
    var vids = scope.querySelectorAll('.und video:not([data-und-v])');
    if (!vids.length) return;
    vids.forEach(function (v) {
      v.dataset.undV = '1';
      v.muted = true;
      v.setAttribute('playsinline', '');
      if (reduced) { v.removeAttribute('autoplay'); v.pause(); }
    });
    if (reduced || !('IntersectionObserver' in window)) return;
    if (!videoIO) {
      videoIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (v.hasAttribute('data-und-intro') || v.dataset.undHold) return;
          if (e.isIntersecting) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { rootMargin: '25% 0px 25% 0px' });
    }
    vids.forEach(function (v) { videoIO.observe(v); });
  }

  /* ---------- 01 Buehne ---------- */

  function webgl() {
    try {
      var c = document.createElement('canvas');
      return !!(window.WebGLRenderingContext && (c.getContext('webgl2') || c.getContext('webgl')));
    } catch (e) { return false; }
  }

  /* ---------- 01 Buehne: realistischer Anflug als Bildsequenz ---------- */

  /* Sprite-Sheets <praefix>0.webp, 1.webp … mit je "per" Bildern in "cols" Spalten.
     Bild i liegt auf Sheet floor(i / per). Gibt setProgress(p) zurueck. */
  function setupSeq(stage, canvas) {
    var first = stage.getAttribute('data-und-seq');
    var n = parseInt(stage.getAttribute('data-und-seq-n'), 10) || 0;
    var per = parseInt(stage.getAttribute('data-und-seq-per'), 10) || 24;
    var cols = parseInt(stage.getAttribute('data-und-seq-cols'), 10) || 6;
    var fw = parseInt(stage.getAttribute('data-und-seq-fw'), 10) || 640;
    var fh = parseInt(stage.getAttribute('data-und-seq-fh'), 10) || 360;
    if (!first || n < 2 || !canvas) return null;
    var ctx = canvas.getContext('2d');
    canvas.width = fw; canvas.height = fh;
    var sheets = Math.ceil(n / per), imgs = [], ok = [], cur = -1, want = 0;
    var src = function (k) { return first.replace(/0\.webp/, k + '.webp'); };
    function draw() {
      var i = want, k = Math.floor(i / per);
      while (k >= 0 && !ok[k]) { k--; i = k * per + per - 1; }   /* naechstes geladenes Bild davor */
      if (k < 0 || i === cur) return;
      var j = i % per;
      ctx.clearRect(0, 0, fw, fh);
      ctx.drawImage(imgs[k], (j % cols) * fw, Math.floor(j / cols) * fh, fw, fh, 0, 0, fw, fh);
      cur = i;
    }
    (function load(k) {
      if (k >= sheets) return;
      var im = new Image();
      im.decoding = 'async';
      im.onload = function () { ok[k] = true; if (k === 0) stage.classList.add('is-3d'); draw(); load(k + 1); };
      im.onerror = function () { load(k + 1); };
      imgs[k] = im;
      im.src = src(k);
    })(0);
    return {
      setProgress: function (p, lite) {
        /* Bilder ueber den ganzen Anflug; am Ende bleibt das Nahbild stehen,
           die naechste Sektion schiebt sich darueber */
        want = Math.round(clamp(p, 0, 1) * (n - 1));
        draw();
      }
    };
  }

  /* Atlas-Variante: jedes Bild ist auf den Flakon zugeschnitten und in
     Bildkarten gepackt. Manifest: { w, h, sheets, frames: [[sheet, sx, sy, sw, sh, dx, dy], ...] }
     (dx/dy im Koordinatenraum w x h). Haelt die Aufloesung hoch bei kleiner Datei. */
  function setupAtlas(stage, canvas) {
    var url = stage.getAttribute('data-und-atlas');
    if (!url || !canvas || !window.fetch) return null;
    var ctx = canvas.getContext('2d');
    var man = null, imgs = [], ok = [], want = 0, cur = -1, centers = null, mode = '';
    /* Mobil: Ausschnitt, der dem Flakon folgt (Mitte geglaettet). Breite im
       Bildraum: 640 am Anfang (Flakon gross), 920 am Ende (Flakon etwa bildbreit) */
    function frameCenters(m) {
      var raw = m.frames.map(function (f) { return f[3] > 1 ? [f[5] + f[3] / 2, f[6] + f[4] / 2] : null; });
      var last = [m.w / 2, m.h / 2];
      raw = raw.map(function (c) { return (last = c || last); });
      return raw.map(function (_, i) {
        var sx = 0, sy = 0, n = 0;
        for (var k = Math.max(0, i - 12); k <= Math.min(raw.length - 1, i + 12); k++) { sx += raw[k][0]; sy += raw[k][1]; n++; }
        return [sx / n, sy / n];
      });
    }
    function fit() {
      var m = desktop() ? 'full' : 'crop';
      if (!man) return;
      if (m === 'crop') {
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var w = Math.round(canvas.clientWidth * dpr), h = Math.round(canvas.clientHeight * dpr);
        if (w && h && (canvas.width !== w || canvas.height !== h)) { canvas.width = w; canvas.height = h; cur = -1; }
      } else if (canvas.width !== man.w || canvas.height !== man.h) {
        canvas.width = man.w; canvas.height = man.h; cur = -1;
      }
      if (m !== mode) { mode = m; cur = -1; }
    }
    function draw() {
      if (!man) return;
      var i = want, f = man.frames[i];
      while (i > 0 && !ok[f[0]]) { i--; f = man.frames[i]; }
      if (!ok[f[0]] || i === cur) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      if (mode === 'crop') {
        var t = i / (man.frames.length - 1);
        var cw = 640 + 280 * t, ch = cw * canvas.height / canvas.width;
        var c = centers[i], s = canvas.width / cw;
        var x0 = c[0] - cw / 2, y0 = Math.min(Math.max(c[1] - ch / 2, 0), Math.max(man.h - ch, 0));
        ctx.drawImage(imgs[f[0]], f[1], f[2], f[3], f[4], (f[5] - x0) * s, (f[6] - y0) * s, f[3] * s, f[4] * s);
      } else {
        ctx.drawImage(imgs[f[0]], f[1], f[2], f[3], f[4], f[5], f[6], f[3], f[4]);
      }
      cur = i;
    }
    window.addEventListener('resize', function () { fit(); draw(); });
    fetch(url).then(function (r) { return r.json(); }).then(function (m) {
      man = m;
      centers = frameCenters(m);
      fit();
      (function load(k) {
        if (k >= m.sheets) return;
        var im = new Image();
        im.decoding = 'async';
        im.onload = function () { ok[k] = true; if (k === 0) stage.classList.add('is-3d'); draw(); load(k + 1); };
        im.onerror = function () { load(k + 1); };
        imgs[k] = im;
        im.src = url.replace(/atlas\.json/, 'atlas-' + k + '.webp');
      })(0);
    }).catch(function () {});
    return {
      setProgress: function (p) {
        if (!man) return;
        want = Math.round(clamp(p, 0, 1) * (man.frames.length - 1));
        draw();
      }
    };
  }

  /* Intro (einmal) → Loop: das Intro endet im ersten Bild des Loops */
  function setupIntro(media) {
    var intro = media && media.querySelector('[data-und-intro]');
    var loop = media && media.querySelector('.und-hero__loop');
    if (!intro || !loop) return;
    loop.dataset.undHold = '1';
    var start = function () {
      if (!loop.dataset.undHold) return;
      delete loop.dataset.undHold;
      loop.currentTime = 0;
      var p = loop.play();
      if (p && p.catch) p.catch(function () {});
      intro.classList.add('is-done');
    };
    if (reduced) { intro.classList.add('is-done'); intro.pause(); return; }
    intro.addEventListener('ended', start);
    intro.addEventListener('error', start);
    /* Sicherheitsnetz, falls das Intro nicht startet (Energiesparmodus, Autoplay-Sperre) */
    setTimeout(function () { if (intro.readyState < 2 && intro.currentTime === 0) start(); }, 6000);
  }

  function setupHero(hero) {
    if (hero.dataset.undReady) return;
    hero.dataset.undReady = '1';

    var media = hero.querySelector('.und-hero__media');
    var stage = hero.querySelector('.und-stage');
    var pin = hero.querySelector('.und-hero__pin');
    var bar = hero.querySelector('.und-sticky');
    var buy = hero.querySelector('.und-hero__buy');
    var pinned = hero.classList.contains('und-hero--pin');
    var bottle = null;

    setupIntro(media);
    var seq = null;
    if (stage && !reduced) {
      if (stage.hasAttribute('data-und-atlas')) seq = setupAtlas(stage, stage.querySelector('canvas'));
      else if (stage.hasAttribute('data-und-seq')) seq = setupSeq(stage, stage.querySelector('canvas'));
    }

    /* 3D-Flakon nachladen (Modul), Standbild bleibt bis dahin stehen */
    var mod = stage && stage.getAttribute('data-und-3d');
    var canvas = stage && stage.querySelector('canvas');
    if (mod && canvas && !reduced && webgl()) {
      /* Als <script type="module"> laden: Shopify minifiziert Theme-JS und
         wuerde ein dynamisches import() in require() umschreiben */
      var mount = function () {
        var api = window.UndeniableBottle3D;
        if (!api || bottle) return;
        bottle = api.mountBottle(canvas, {
          label: stage.getAttribute('data-und-label'),
          choreo: stage.getAttribute('data-und-choreo') || 'spiral',
          lite: function () { return !desktop() || !pinned; },
          onReady: function () { stage.classList.add('is-3d'); request(); }
        });
        request();
      };
      if (window.UndeniableBottle3D) mount();
      else {
        window.addEventListener('und:3d', mount, { once: true });
        if (!document.querySelector('script[data-und-3d]')) {
          var s = document.createElement('script');
          s.type = 'module';
          s.src = mod;
          s.setAttribute('data-und-3d', '');
          document.head.appendChild(s);
        }
      }
    }

    tasks.push(function () {
      var p;
      if (pinned && desktop()) {
        /* die letzten 100vh gehoeren dem Ueberschieben der Folgesektion: der Anflug ist dann fertig */
        var hr = hero.getBoundingClientRect();
        var run = hr.height - pin.offsetHeight - window.innerHeight;
        p = run > 0 ? clamp(-hr.top / run, 0, 1) : 0;
      } else {
        /* ohne Pin: 0 ganz oben, 1 sobald die Buehne zu 70 % aus dem Bild ist */
        var r = (stage || hero).getBoundingClientRect();
        var end = r.top + window.scrollY + r.height * 0.7;
        p = clamp(window.scrollY / Math.max(end, 1), 0, 1);
      }
      if (bottle) bottle.setProgress(p);
      if (seq) seq.setProgress(p, !(pinned && desktop()));
      if (media && !reduced) media.style.setProperty('--und-zoom', (1.06 - p * 0.06).toFixed(3));
      var flying = pinned && desktop();
      hero.classList.toggle('is-turned', p > 0.03);
      hero.classList.toggle('is-flying', flying && p > 0.06);
      if (bar && flying) bar.classList.toggle('is-on', p > 0.5);
    });

    /* Ohne Anflug (mobil / ohne Pin): Leiste, sobald der Kaufbereich oben raus ist */
    if (bar && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (pinned && desktop()) return;
        var e = entries[0];
        bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.bottom < 0);
      }, { threshold: 0 }).observe(buy);
    }
  }

  /* ---------- 03 Noten ---------- */

  function setupComp(comp) {
    if (comp.dataset.undReady) return;
    comp.dataset.undReady = '1';
    var pin = comp.querySelector('.und-comp__pin');
    var track = comp.querySelector('.und-comp__track');
    var panels = comp.querySelectorAll('.und-panel');
    var dots = comp.querySelectorAll('.und-comp__progress i');
    if (!pin || !track || !panels.length) return;

    var current = -1;
    var setActive = function (i) {
      if (i === current) return;
      current = i;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    };
    setActive(0);

    tasks.push(function () {
      if (!desktop()) { track.style.transform = ''; return; }
      var p = pinProgress(comp, pin.getBoundingClientRect().height);
      var max = track.scrollWidth - window.innerWidth;
      track.style.transform = 'translate3d(' + (-p * max).toFixed(1) + 'px,0,0)';
      setActive(Math.round(p * (panels.length - 1)));
    });

    /* Mobil: nativer Wischer */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (desktop()) return;
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio > 0.6) setActive([].indexOf.call(panels, e.target));
        });
      }, { root: track, threshold: [0.6] });
      panels.forEach(function (p) { io.observe(p); });
    }
  }

  /* ---------- 04 Studien ---------- */

  function setupSignal(sig) {
    if (sig.dataset.undReady) return;
    sig.dataset.undReady = '1';
    var pin = sig.querySelector('.und-signal__pin');
    var slides = sig.querySelectorAll('.und-slide');
    var dots = sig.querySelectorAll('.und-signal__dots i');
    if (!pin || !slides.length) return;
    var current = -1;
    tasks.push(function () {
      var p = pinProgress(sig, pin.getBoundingClientRect().height);
      var idx = clamp(Math.floor(p * slides.length), 0, slides.length - 1);
      if (idx === current) return;
      current = idx;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === idx); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k <= idx); });
    });
  }

  /* ---------- 05 Fuer sie ---------- */

  function setupHer(her) {
    if (her.dataset.undReady) return;
    her.dataset.undReady = '1';

    var quote = her.querySelector('.und-her__quote');
    if (!quote || reduced) return;
    if (!quote.dataset.undSplit) {
      quote.dataset.undSplit = '1';
      var words = quote.textContent.trim().split(/\s+/);
      quote.textContent = '';
      words.forEach(function (w, i) {
        var s = document.createElement('span');
        s.className = 'und-w';
        s.textContent = w;
        quote.appendChild(s);
        if (i < words.length - 1) quote.appendChild(document.createTextNode(' '));
      });
    }
    var spans = quote.querySelectorAll('.und-w');
    tasks.push(function () {
      var r = quote.getBoundingClientRect();
      var vh = window.innerHeight;
      var p = clamp((vh * 0.88 - r.top) / (vh * 0.45), 0, 1);
      var n = Math.round(p * spans.length);
      spans.forEach(function (w, i) { w.classList.toggle('is-on', i < n); });
    });
  }

  /* ---------- 06 Stimmen ---------- */

  function setupVoices(v) {
    if (v.dataset.undReady) return;
    v.dataset.undReady = '1';
    var items = v.querySelectorAll('.und-voice');
    var nav = v.querySelectorAll('.und-voices__nav button');
    if (items.length < 2) return;
    var i = 0, timer = 0, dur = 7000, paused = false;

    var show = function (k) {
      i = (k + items.length) % items.length;
      items.forEach(function (it, n) { it.classList.toggle('is-on', n === i); });
      nav.forEach(function (b, n) {
        b.classList.toggle('is-on', n === i);
        b.classList.toggle('is-done', n < i);
        b.setAttribute('aria-current', n === i ? 'true' : 'false');
        if (n === i) { var bar = b.querySelector('i'); bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
      });
    };
    var schedule = function () {
      clearTimeout(timer);
      if (reduced) return;
      timer = setTimeout(function () { if (!paused) show(i + 1); schedule(); }, dur);
    };
    v.style.setProperty('--und-dur', dur + 'ms');
    nav.forEach(function (b, n) { b.addEventListener('click', function () { show(n); schedule(); }); });
    v.addEventListener('pointerenter', function () { paused = true; });
    v.addEventListener('pointerleave', function () { paused = false; });
    show(0);
    schedule();
  }

  /* ---------- Finale → Produktformular ---------- */

  function setupSubmitters(scope) {
    scope.querySelectorAll('[data-und-submit]:not([data-und-ready])').forEach(function (btn) {
      btn.dataset.undReady = '1';
      btn.addEventListener('click', function (e) {
        var form = document.querySelector('.und-hero form[is="product-form"]') || document.querySelector('form[is="product-form"]');
        if (!form) return;
        e.preventDefault();
        if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit();
      });
    });
  }

  /* ---------- Init ---------- */

  function init(scope) {
    scope = scope || document;
    setupReveal(scope);
    setupVideos(scope);
    setupSubmitters(scope);
    scope.querySelectorAll('.und-hero').forEach(setupHero);
    scope.querySelectorAll('.und-comp').forEach(setupComp);
    scope.querySelectorAll('.und-signal').forEach(setupSignal);
    scope.querySelectorAll('.und-her').forEach(setupHer);
    scope.querySelectorAll('.und-voices').forEach(setupVoices);
    request();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.UndeniablePDP = { init: init };
})();
